import { BaseDocument } from '../../../base/BaseDocument';
import { IBaseEntry } from '../../../base/interfaces/IBaseEntry';

export class LayoutType extends BaseDocument implements IBaseEntry {
    picture:string;
    link:string;
    itemId:string;
    itemName:string;
    itemQuantity:number;
    itemPrice:number;
    itemPriceInternal:number;
    itemAmount:number;
    itemAmountInternal:number;
    outsideLeft:boolean;
    outsideRight:boolean;
    outsideCenter:boolean;
    insideLeft:boolean;
    insideRight:boolean;
    insideCenter:boolean;
    parentTypeId:string;
    hasSubTypes:boolean
}
